import React from 'react';

interface DecoratorProps {
    className?: string;
}

export const Decorator = ({ className = '' }: DecoratorProps) => {
    return (
        <svg
            width="118"
            height="114"
            viewBox="0 0 118 114"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g opacity="0.3">
                <path d="M118 105H59" stroke="url(#paint0_linear_2413_20469)" />
                <path d="M107 57L59 57" stroke="#E25636" />
                <path d="M59 105L59 57" stroke="#E25636" />
                <path d="M107 114L107 57" stroke="url(#paint1_linear_2413_20469)" />
            </g>
            <circle
                cx="59"
                cy="105"
                r="1"
                transform="rotate(180 59 105)"
                fill="#F24040"
            />
            <circle
                cx="59"
                cy="57"
                r="1"
                transform="rotate(180 59 57)"
                fill="#F24040"
            />
            <circle
                cx="107"
                cy="57"
                r="1"
                transform="rotate(180 107 57)"
                fill="#F24040"
            />
            <g opacity="0.3">
                <path d="M0 9H59" stroke="url(#paint2_linear_2413_20469)" />
                <path d="M11 57L59 57" stroke="#E25636" />
                <path d="M59 9L59 57" stroke="#E25636" />
                <path d="M11 0L11 57" stroke="url(#paint3_linear_2413_20469)" />
            </g>
            <circle cx="59" cy="9" r="1" fill="#F24040" />
            <circle cx="59" cy="57" r="1" fill="#F24040" />
            <circle cx="11" cy="57" r="1" fill="#F24040" />
            <defs>
                <linearGradient
                    id="paint0_linear_2413_20469"
                    x1="59"
                    y1="104.5"
                    x2="118"
                    y2="104.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E25636" />
                    <stop offset="1" stopColor="#7C2F1E" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2413_20469"
                    x1="107.5"
                    y1="57"
                    x2="107.5"
                    y2="114"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E25636" />
                    <stop offset="1" stopColor="#7C2F1E" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_2413_20469"
                    x1="59"
                    y1="9.5"
                    x2="0"
                    y2="9.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E25636" />
                    <stop offset="1" stopColor="#7C2F1E" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_2413_20469"
                    x1="10.5"
                    y1="57"
                    x2="10.5"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E25636" />
                    <stop offset="1" stopColor="#7C2F1E" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
